import classnames from 'classnames';

import type { PolymorphicComponent } from '@hh.ru/magritte-types';
import type { NumberPagesActionProps } from '@hh.ru/magritte-ui-number-pages/types';
import { Text } from '@hh.ru/magritte-ui-typography';

import styles from './styles.less';

export const NumberPagesAction: PolymorphicComponent<NumberPagesActionProps, 'button'> = ({
    children,
    selected = false,
    isIcon = false,
    Element = 'button',
    'aria-label': ariaLabel,
    page,
    ...props
}) => {
    const buttonProps = Element === 'button' ? ({ type: 'button' } as const) : {};

    return (
        <li>
            <Text typography="label-2-regular">
                <Element
                    {...props}
                    {...buttonProps}
                    aria-current={selected}
                    aria-label={ariaLabel}
                    className={classnames(styles.numberPagesAction, {
                        [styles.numberPagesActionSelected]: selected,
                        [styles.numberPagesActionIcon]: isIcon,
                    })}
                >
                    {children}
                </Element>
            </Text>
        </li>
    );
};
